<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="bank">
    <th mat-header-cell class="header" *matHeaderCellDef>Número Banco 2</th>
    <td mat-cell *matCellDef="let element">
      {{ element.Bank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="branch">
    <th mat-header-cell class="header" *matHeaderCellDef>Número Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.Branch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="fund">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Identificação Fundo
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.Fund }}
    </td>
  </ng-container>

  <ng-container matColumnDef="account">
    <th mat-header-cell class="header" *matHeaderCellDef>Número Conta</th>
    <td mat-cell *matCellDef="let element">
      {{ element.Account }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions" sticky>
    <th mat-header-cell class="header" *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element" class="actions"></td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="ColumnsQuota.length">
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <div class="title-description">
            <h5>Erros encontrados:</h5>
          </div>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsQuota"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsQuota"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
